module.exports = __webpack_public_path__ + "static/img/login1.3a17098.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/login1.png
// module id = 1241
// module chunks = 0